// template: mui
import * as React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
const SvgArrowRight = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M14.29 5.71a.996.996 0 0 0 0 1.41L18.17 11H3c-.55 0-1 .45-1 1s.45 1 1 1h15.18l-3.88 3.88a.996.996 0 1 0 1.41 1.41l5.59-5.59a.996.996 0 0 0 0-1.41l-5.6-5.58a.996.996 0 0 0-1.41 0Z"
      />
    </SvgIcon>
  )
}
// TODO: Replace with EastIcon in @weblite/icons
export default SvgArrowRight
